import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'
import { useSetFilters } from '@/legacy-src/components/filters/hooks/useSetFilters'

import { type SessionTypeFilter } from '@/src/domains/therapist-filters/constants'
import { parseTherapistSessionTypeFilterValue } from '@/src/domains/therapist-filters/utils/parseTherapistSessionTypeFilterValue'

export const useTherapistSessionTypeFilter = () => {
  const filterSessionTypeValue = useGetFilterValue('sessionType')
  const setFilters = useSetFilters()

  const type = parseTherapistSessionTypeFilterValue(filterSessionTypeValue[0])

  const handleTypeFilter = (value: SessionTypeFilter | undefined) => {
    setFilters([
      {
        slug: 'sessionType',
        value: value === undefined ? [] : value,
      },
      {
        slug: 'sessionLocation',
        value: [],
      },
    ])
  }

  return {
    type,
    rawType: filterSessionTypeValue[0],
    handleTypeFilter,
  }
}
